import PropTypes from 'prop-types';
import { Box, FormControlLabel } from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Controller, useForm } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import MDInput from 'components/MDInput';

export function SimpleMailInputNodeForm({ id, data, onUpdateData }) {
  const { formatMessage: msg } = useIntl();

  const { control, watch } = useForm({
    defaultValues: {
      protocol: data?.protocol || 'imaps',
      hostURI: data?.hostURI || '',
      port: data?.port || '993',
      username: data?.username || '',
      password: data?.password || '',
      delay: data?.delay ?? 5,
      delete: data?.delete ?? true
    }
  });

  const formValues = watch();

  useEffect(() => {
    onUpdateData?.({
      id,
      data: {
        ...data,
        protocol: formValues.protocol,
        hostURI: formValues.hostURI,
        port: formValues.port,
        username: formValues.username,
        password: formValues.password,
        delay: formValues.delay,
        delete: formValues.delete
      }
    });
  }, [formValues, data, id, onUpdateData]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Controller
        sx={{ mb: 2 }}
        name="protocol"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.mail.protocol.label' })}
            variant="filled"
            fullWidth
            size="small"
          />
        )}
      />

      <Controller
        sx={{ mb: 2 }}
        name="hostURI"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.mail.host.label' })}
            variant="filled"
            fullWidth
            size="small"
          />
        )}
      />

      <Controller
        sx={{ mb: 2 }}
        name="port"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.mail.port.label' })}
            variant="filled"
            fullWidth
            size="small"
          />
        )}
      />

      <Controller
        sx={{ mb: 2 }}
        name="username"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.mail.username.label' })}
            variant="filled"
            fullWidth
            size="small"
            autoComplete="off"
          />
        )}
      />

      <Controller
        sx={{ mb: 2 }}
        name="password"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            type="password"
            label={msg({ id: 'field.mail.password.label' })}
            variant="filled"
            fullWidth
            size="small"
            autoComplete="new-password"
          />
        )}
      />

      <Controller
        sx={{ mb: 2 }}
        name="delay"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            type="number"
            label={msg({ id: 'field.mail.delay.label' })}
            variant="filled"
            fullWidth
            size="small"
          />
        )}
      />

      <Controller
        name="delete"
        control={control}
        render={({ field: { onChange, value, ...field } }) => (
          <FormControlLabel
            control={<Checkbox onChange={onChange} checked={value} {...field} />}
            label={msg({ id: 'field.mail.delete.label' })}
          />
        )}
      />
    </Box>
  );
}

SimpleMailInputNodeForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    protocol: PropTypes.string,
    hostURI: PropTypes.string,
    port: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string,
    delay: PropTypes.number,
    delete: PropTypes.bool
  }),
  onUpdateData: PropTypes.func.isRequired
};
